import React from "react";
import Layout from "../../shared/Layout/Layout";
import logo from "../../assets/logo.png";
import styles from "./Privacy.module.scss";

const Privacy = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.banner}>
            <div className={styles.overlay}></div>
            <h1>
              Privacy <br /> Policy.
            </h1>
          </div>

          <main className={styles.main}>
            <div className={styles.left}>
              <ul>
                <li className={styles.active}>
                  What Personal Data Do We Collect and Why.
                </li>
                <li>Security Of Your Data.</li>
                <li>NFT Transfers</li>
                <li>Security Of Your Data</li>
                <li>Your Rights.</li>
                <li>Contact Us.</li>
              </ul>
            </div>
            <div className={styles.right}>
              <img src={logo} alt="logo" />
              <h2>
                What Personal Data Do <br /> We Collect and Why.
              </h2>
              <h4>General</h4>
              <p>
                We may collect your personal data from direct and indirect
                interactions with you to provide our services as agreed by you
                or to fulfill our contractual obligations with you.
              </p>

              <p>
                In this regard we may gather personal data that may include
                your:
                <br />
                <br />
                Name, address, nationality, email address, telephone number,
                bank account details, job title, name of employer, bank account
                details, tax ID or your national insurance number, forms of
                identification.
              </p>

              <p>
                We may use this information to:
                <br />
                <br />
                Set up meetings with you, maintain a record of your contacts,
                respond to your enquiries and fulfill your requests, assist you
                with your transactions or provide you with investor related
                services.
                <br />
                <br />
                The use and processing of your personal data is necessary for
                our legitimate interests in providing our services, carrying out
                of administrative duties, the running of our business and in
                order to make or advise on investment decisions.
              </p>

              <h4 style={{ marginTop: "60px" }}>Communications And Correspondence</h4>
              <p>
                In the course of communications or correspondence with you we
                may need to collect your personal data in order to develop our
                services and offerings and inform our marketing strategy.
              </p>
              <p>
                providing our services, administrative purposes, making or
                advising on investment decisions, performance of contractual
                relationships, to comply with relevant regulations and laws, tax
                and compliance obligations including anti money laundering
                regulations and criminal background checks.
              </p>
              <p>
                running our business, administrative purposes, to enable
                performance of contractual relations, allow us to progress your
                potential employment or internship job career.
              </p>
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;
